import flattenNodes from 'react-keyed-flatten-children'
import Link from 'next/link'
import * as React from 'react'
import clsx from 'clsx'

import SadIcon from 'assets/icons/emoji-sad.svg'

export interface EmptyStateProps {
  children?: React.ReactNode
  title: string
  subtitle: string
  className?: string
}

interface EmptyStateActionProps {
  children: React.ReactNode
  onClick?: (event: any) => void
  href?: string
}

export const EmptyStateAction = ({
  href,
  onClick,
  children,
  ...props
}: EmptyStateActionProps) => {
  const className =
    'bg-white text-[#F66951] text-base font-semibold py-2 px-4 rounded-md border border-solid border-[#CACCCF]'
  if (href) {
    return (
      <a {...props} href={href} className={className}>
        {children}
      </a>
    )
  } else {
    return (
      <button {...props} onClick={onClick} className={className}>
        {children}
      </button>
    )
  }
}

export const EmptyState = ({
  children,
  title,
  subtitle,
  className,
}: EmptyStateProps) => {
  const classes = clsx(
    'flex flex-col justify-center text-center h-full',
    className
  )
  return (
    <div className={classes}>
      <div className="bg-[#EDEDED] rounded-full w-14 h-14 flex items-center justify-center self-center mb-3">
        <SadIcon />
      </div>
      <h2 className="text-base font-semibold mb-3">{title}</h2>
      <p className="text-sm mb-3 leading-4 px-8">{subtitle}</p>
      {React.Children.map(flattenNodes(children), (child) => {
        if (typeof child === 'object' && child.type === EmptyStateAction) {
          const { href, ...props } = child.props as EmptyStateActionProps
          if (href) {
            return (
              <div className="flex justify-center mt-1">
                <Link href={href} passHref>
                  <EmptyStateAction {...props} />
                </Link>
              </div>
            )
          }
          return (
            <div className="flex justify-center mt-1">
              <EmptyStateAction {...props} />
            </div>
          )
        }
      })}
    </div>
  )
}

export default EmptyState
